import { l as valibot, L as LoginMailSchema } from "../../../chunks/valibot.js";
import "clsx";
import "@sveltejs/kit/internal";
import "../../../chunks/exports.js";
import "../../../chunks/utils.js";
import "../../../chunks/client2.js";
import "ts-deepmerge";
import "../../../chunks/formData.js";
import "@sveltejs/kit";
import { s as superValidate } from "../../../chunks/superValidate.js";
import "memoize-weak";
import "zod-to-json-schema";
const load = async () => {
  const form = await superValidate(valibot(LoginMailSchema));
  return {
    form
  };
};
export {
  load
};
